import React from "react";
import * as styles from "@styles/EmailValidation.css";
import { Card, CardContent, CardTitle } from "@components/ui/card";
import type { EmailValidationViewProps } from "@ps-bridge/contracts/emailValidation";
import EmailValidationBodyPanel from "@view/panels/authentication/EmailValidationBody.panel";

const EmailValidationView: React.FC<EmailValidationViewProps> = ({
  bodyPhase,
  errorMessage,
  onNavigateToHome,
  onNavigateToLogin,
}) => {
  const pageState = bodyPhase === "success" || bodyPhase === "error" ? "ready" : "init";

  return (
    <div className={styles.page} data-testid="page-email-verify" data-page-state={pageState}>
      <Card className={styles.card}>
        <CardContent>
          <CardTitle className={styles.title}>Email verification</CardTitle>
          <EmailValidationBodyPanel
            bodyPhase={bodyPhase}
            errorMessage={errorMessage}
            onNavigateToHome={onNavigateToHome}
            onNavigateToLogin={onNavigateToLogin}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default EmailValidationView;
